import { Col, Row, Offcanvas, Form, Nav, Alert, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TableComp from "../component/Table";
import { useCallback, useEffect, useState } from "react";
import LinkDriverList from "../component/LinkDriverList";
import GoalAchievedCard from "../component/GoalAchievedCard";
import { MdEmail } from "react-icons/md";
import ApiUtil from "../util/ApiUtil";
import ApiPath from "../util/ApiPath";
import SessionUtil from "../util/SessionUtil";
import Pagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import ReactLoading from "react-loading";
import ListGroup from "../component/ListGroup";
import { HiPhone } from "react-icons/hi2";
import { t } from "i18next";

const CustomRow = ({ rowData, columnNames, handleShow }) => {
  return (
    <tr>
      {columnNames.map((columnName, index) => (
        <td key={index} onClick={() => handleShow(rowData)}>
          {columnName === "userId" ? (
            <span>#{rowData.UserId}</span>
          ) : columnName === "fullName" ? (
            <div className="flex-gap-2">
              <p className="mb-0">
                {rowData?.FullName ? rowData.FullName : "--"}
              </p>
            </div>
          ) : columnName === "Email" ? (
            <div className="flex-gap-2">
              <MdEmail size={16} color="#4285F4" />{" "}
              <p className="mb-0">{rowData?.Email ? rowData.Email : "--"}</p>{" "}
            </div>
          ) : columnName === "Phone Number" ? (
            <div className="flex-gap-2">
              <HiPhone size={16} color={"#3A974C"} />{" "}
              <p className="mb-0">
                {"+" + rowData.AreaCode + "" + rowData.PhoneNumber}
              </p>
            </div>
          ) : columnName === "complaint" ? (
            <p className="mb-0 w-200">
              {rowData?.Complian ? rowData.Complian : "--"}
            </p>
          ) : columnName === "Status" ? (
            rowData.StatusCode === "NEW" || rowData.StatusCode === "ACTIVE" ? (
              <div className="status status-warning">
                <p className="mb-0">{t("New")}</p>
              </div>
            ) : (
              <div className="status status-success">
                <p className="mb-0">{t("Resolved")}</p>
              </div>
            )
          ) : (
            <p className="mb-0">{rowData[columnName]}</p>
          )}
        </td>
      ))}
    </tr>
  );
};

const Contacted = () => {
  const { t } = useTranslation();
  const columnNames = [
    "userId",
    "fullName",
    "Email",
    "Phone Number",
    "complaint",
    "Status",
  ];
  const [sortedData, setSortedData] = useState([]);
  const [show, setShow] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordCount, setRecordCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const isLoggedIn = SessionUtil.isLoggedIn(); // Custom hook or context
  const [type, setType] = useState("USER");
  const [isResolved, setIsResolved] = useState(false);
  const [alertMsg, setAlertMsg] = useState(null);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = (data) => {
    setIsResolved(false);
    setShow(true);
    setRowData(data);
  };
  const getApi = useCallback(async () => {
    // setLoading(true);
    let data = {
      PageNumber: currentPage,
      PageSize: "10",
      OrderBy: "Id Desc",
      ContactUs: {
        Role: type,
      },
    };
    const res = await ApiUtil.postApi(ApiPath.GET_ALL_CONTACT_US, data, "POST");
    if (res.IsSuccessfull) {
      setSortedData(res.Result.ContactUs);
      const totalPage = Math.ceil(res.Result.RecordCount / 10);
      setRecordCount(totalPage);
      setLoading(false);
    }
  }, [currentPage, type]);
  useEffect(() => {
    if (isLoggedIn) {
      getApi();
    }
  }, [getApi, isLoggedIn]);
  const resolveContactUs = async () => {
    setLoadingSubmit(true);

    let data = {
      ContactUsId: rowData.Id,
    };

    const res = await ApiUtil.postApi(
      ApiPath.RESOLVED_CONTACT_US,
      data,
      "POST"
    );
    if (res.IsSuccessfull) {
      setLoadingSubmit(false);
      setShow(false);
      getApi();
      setAlertMsg(true);
      setTimeout(() => {
        setAlertMsg(null);
      }, 5000);
    } else {
      setLoadingSubmit(false);
      setShow(false);
      setAlertMsg(false);
      setTimeout(() => {
        setAlertMsg(null);
      }, 5000);
    }
  };
  const handlePageNumber = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleType = (type) => {
    setType(type);
  };
  return (
    <>
      <Row className="g-0">
        {!loading ? (
          <>
            <Col lg={8} className="position-relative">
              <ListGroup />
              <div className=" mt-4 d-flex justify-content-between gap-2">
                <p className="title">{t("Contact us")}</p>
              </div>
              <Nav variant="tabs" defaultActiveKey="user">
                <Nav.Item>
                  <Nav.Link onClick={() => handleType("USER")} eventKey="user">
                    {t("User")}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    onClick={() => handleType("DRIVER")}
                    eventKey="driver"
                  >
                    {t("Driver")}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              {alertMsg !== null &&
                (alertMsg ? (
                  <Alert variant={"success"} className="mt-3">
                    {t("The complaint resolved successfully")}.
                  </Alert>
                ) : (
                  <Alert variant={"danger"} className="mt-3">
                    {t("There is an error in the process")}.
                  </Alert>
                ))}
              <TableComp
                data={sortedData}
                columnNames={columnNames}
                setSortedData={setSortedData}
              >
                {sortedData.map((rowData, index) => (
                  <CustomRow
                    key={index}
                    rowData={rowData}
                    columnNames={columnNames}
                    handleShow={handleShow}
                  />
                ))}
              </TableComp>
              <Pagination
                current={currentPage}
                total={recordCount}
                onPageChange={(pageNumber) => handlePageNumber(pageNumber)}
                extraClassName="justify-content-end"
              />
            </Col>

            <Col md={1}>
              <div className="divider-vertical mx-auto"></div>
            </Col>
            <Col lg={3} className="mt-5">
              <LinkDriverList data={[]} type="linkDriver" />
              <GoalAchievedCard />
            </Col>
          </>
        ) : (
          <Col lg={12} className="loading-style">
            <ReactLoading
              type={"bars"}
              color={"#c8c8c8"}
              height={"50px"}
              width={"50px"}
            />
          </Col>
        )}
      </Row>
      <Offcanvas placement="end" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{t("User Information")}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {/* Full Name */}
          <Form.Group className="mb-3" controlId="DriverNameEn">
            <Form.Label className="font-SemiBold">{t("fullName")}</Form.Label>
            <Form.Control
              type="text"
              placeholder={t("fullName")}
              value={rowData?.FullName || ""}
              disabled
            />
          </Form.Group>
          {/* email */}
          <Form.Group className="mb-3" controlId="Email">
            <Form.Label className="font-SemiBold">{t("Email")}</Form.Label>
            <Form.Control
              type="text"
              placeholder={t("Email")}
              value={rowData?.Email || ""}
              disabled
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="complaint">
            <Form.Label className="font-SemiBold">{t("Complaint")}</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder={t("Complaint")}
              value={rowData?.Complian || ""}
              disabled
            />
          </Form.Group>
          <Form.Check
            type={"checkbox"}
            id={`Resolved`}
            label={t("Resolved")}
            checked={isResolved || rowData.StatusCode === "RESOLVED"}
            onChange={(e) => setIsResolved(e.target.checked)}
            disabled={rowData.StatusCode === "RESOLVED"}
          />
          {rowData.StatusCode !== "RESOLVED" && (
            <Button
              aria-label="Aria label"
              type="submit"
              className="btn-main w-100 mt-4"
              onClick={resolveContactUs}
              disabled={loadingSubmit}
            >
              <div className="flex-gap-2 justify-content-center">
                {t("Save")}
                {loadingSubmit && (
                  <ReactLoading
                    type={"spin"}
                    color={"#c8c8c8"}
                    height={"20px"}
                    width={"20px"}
                  />
                )}
              </div>
            </Button>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Contacted;
